import { Component, OnInit, Input, EventEmitter, OnDestroy, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { MonitoredTrain } from '../../models/monitored-train';
import { TranslateService } from '@ngx-translate/core';
import {Subscription} from "rxjs";
import { TableStateService } from '../../../../shared/services/table-state.service';
import { ProjectConfiguration } from '@/app/features/project/models/project-configuration';

@Component({
  selector: 'app-monitored-trains-table',
  template: require('./monitored-trains-table.component.html'),
  styles: [require('./monitored-trains-table.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonitoredTrainsTableComponent implements OnInit, OnChanges, OnDestroy  {

  @Input() projectId: number;
  @Input() monitoredTrains: MonitoredTrain[];  
  @Input() isSingleTrain: boolean;
  @Input() trainTableKey: string;
  @Input() projectConfiguration: ProjectConfiguration;

  @Output() investigateTrain = new EventEmitter<MonitoredTrain>();
  @Output() rightClick = new EventEmitter<MonitoredTrain>();

  trains: MonitoredTrain[];
  languageChangeSubscription: Subscription;

  tableConfiguration: any = {
    paginate: true,
    sortableMode: 'multiple',
    defaultPagination: 250,
    itemsPerPageOptions: [50,100,250,500],
    exportFilename: 'trains-table'
  }

  columns: any[] ;

  constructor(
    private translate: TranslateService,
    public tableState: TableStateService
  ) {
    this.languageChangeSubscription = this.translate.onLangChange.subscribe ( () => {
      this.refreshMonitoredTable();
    } );
  }

  ngOnInit(): void {
    this.refreshMonitoredTable ();
  }

  refreshMonitoredTable = () => {
    this.columns = [{
    header: this.translate.instant('I18N_MONITORING.PROJECT'),
    field: 'projectName',
    type: 'text'
  },
  {
    header: this.translate.instant('I18N_MONITORING.TRAIN'),
    field: 'name',
    type: 'text'
  },
  {
    header: this.translate.instant('I18N_MONITORING.IN_DEPOT'),
    field: 'inDepot',
    searchable: false,
    type: 'boolean'
  },
  {
    header: this.translate.instant('I18N_MONITORING.TRIP'),
    field: 'currentTrip.percent',
    type: 'current-trip'
  },
  {
    header: this.translate.instant('I18N_MONITORING.LOCATION'),
    field: 'location.abbreviatedLocation',
    type: 'text'
  },
  {
    header: this.translate.instant('I18N_MONITORING.NEXT_TRIP'),
    field: 'nextTrip.remainingTimeToStart',
    type: 'next-trip'
  },
  {
    header: this.translate.instant('I18N_MONITORING.SPEED'),
    field: 'speed'
  }, {
      header: this.translate.instant('I18N_MONITORING.USERS'),
    orderable: false,
    searchable: false,
  },
  {
    header: this.translate.instant('I18N_MONITORING.LINKS'),
    orderable: false,
    searchable: false,
    width: '200px'
  }, {
      header: this.translate.instant('I18N_MONITORING.DOWN'),
    field: 'totalDownloadRate',
    //tooltip: 'Download speed in mbit/s'
  },
  {
    header: this.translate.instant('I18N_MONITORING.UP'),
    field: 'totalUploadRate',
    //tooltip: 'Upload speed in mbit/s',
  },
  {
    header: this.translate.instant('I18N_MONITORING.CHECKED'),
    field: 'timestamp',
    searchable: false,
    type: 'boolean'
  },
  {
    header: this.translate.instant('I18N_MONITORING.LAST_SEEN'),
    field: 'lastSeen',
    //tooltip: 'Upload speed in mbit/s',
  }]
    this.columns = this.columns.map(column => {
      column.visible = true;
      if (column.field === 'projectName') {
        column.visible = !(this.projectId > 0);
      }
      return column;
    })
  }


  ngOnChanges = () => {
   
  }
  
  onInvestigateTrain = (train: MonitoredTrain) => {
    this.investigateTrain.emit(train)
  }

  onRightClick = (train: MonitoredTrain) => {
    
  }

  trackByTrainUniqueID(train: MonitoredTrain): string {
    return train.uid;
  }

  ngOnDestroy(): void {
   
  }

}